var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaiwan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_8120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C4.12172 7.87828 7.61737 4.38263 12 0C18.6274 0 24 5.37262 24 12Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12C12 5.37262 12 4.59131 12 0C5.37262 0 0 5.37262 0 12H12Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4348 7.02287L8.96925 7.7123L9.74963 9.13163L8.15827 8.82713L7.95657 10.4348L6.84816 9.25243L5.73966 10.4348L5.53805 8.82713L3.94665 9.13154L4.72702 7.71221L3.26152 7.02287L4.72707 6.33357L3.94665 4.91419L5.538 5.21865L5.73971 3.61102L6.84816 4.7934L7.95661 3.61102L8.15827 5.21865L9.74968 4.91419L8.96925 6.33362L10.4348 7.02287Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.84834 9.25636C8.082 9.25636 9.08208 8.25629 9.08208 7.02263C9.08208 5.78897 8.082 4.78889 6.84834 4.78889C5.61469 4.78889 4.61461 5.78897 4.61461 7.02263C4.61461 8.25629 5.61469 9.25636 6.84834 9.25636Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.84816 8.21311C6.19186 8.21311 5.65796 7.67916 5.65796 7.02286C5.65796 6.36656 6.19191 5.83261 6.84816 5.83261C7.50446 5.83261 8.03841 6.36656 8.03841 7.02286C8.03836 7.67916 7.50436 8.21311 6.84816 8.21311Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_8120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaiwan);
export default __webpack_public_path__ + "static/media/taiwan.8d95bd050e01c399b6ed76c6d3ba0ea4.svg";
export { ForwardRef as ReactComponent };